import React from 'react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  return <section className="py-32 md:py-44 bg-charcoal text-white" data-id="element-197">
      <div className="container mx-auto px-6 md:px-12" data-id="element-198">
        <FadeIn data-id="element-199">
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-200">
            <p className="font-serif text-2xl md:text-4xl leading-relaxed italic mb-12 text-white/80 font-light" data-id="element-201">
              "Our wedding at Code 11 was nothing short of magical. The
              attention to detail, the exquisite food, and the stunning
              atmosphere made it the best day of our lives."
            </p>
            <div className="w-12 h-[1px] bg-copper mb-8" data-id="element-202"></div>
            <div data-id="element-203">
              <p className="font-sans tracking-[0.2em] uppercase text-xs mb-2 text-white/90" data-id="element-204">
                Sarah & James
              </p>
              <p className="font-sans text-white/40 text-[10px] uppercase tracking-widest" data-id="element-205">
                September 2023
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}